export default __webpack_public_path__ + "static/media/share.e06bd023.svg";